import React from 'react'
import { colors } from 'shared/assets/styles'
import styled from 'styled-components'
import { H4 } from 'app/common/typography'
import { FormattedMessage } from 'react-intl'
import { media } from 'app/assets/styles'

const { shadow, text } = colors

type Props = {
    labelKey: string,
    labelValues?: {},
    active: boolean,
    handleClick: () => void
}

const SwitchButton = (props: Props) => {
    const { labelKey, labelValues, active, handleClick } = props
    return (
        <FormattedMessage id={labelKey} values={labelValues}>
            {(label: string) => (
                <ButtonContainer active={active} onClick={handleClick}>
                    <StyledH4 color={active ? text : shadow}>{label}</StyledH4>
                </ButtonContainer>
            )}
        </FormattedMessage>
    )
}

const ButtonContainer = styled.div`
    margin: 0 5% 20px;
    min-width: 150px;
    padding-bottom: 10px;
    border-bottom: 2px solid;
    border-bottom-color: ${props => (props.active ? text : 'transparent')};
    cursor: pointer;
    ${media.medium`
        margin: 0 20px 40px;
    `};
`

const StyledH4 = styled(H4)`
    text-align: center;
`

export { SwitchButton }
